export type ShortPlacementId<TPlacementId extends string> =
  `${TPlacementId extends `advt_${infer Id}` ? Id : TPlacementId}`;

export namespace ShortPlacementId {
  export const RegExp = /^advt_(.*)$/;

  export function from<TPlacementId extends string>(placementId: TPlacementId) {
    return placementId.replace(
      ShortPlacementId.RegExp,
      '$1'
    ) as ShortPlacementId<TPlacementId>;
  }
}
